import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { fire } from "../Firebase/firebase";
import { Redirect } from "react-router-dom";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      isLoggedIn: true,
      isToggleOn: true,
      text: "Visible"
    };
    this.handleClick = this.handleClick.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  componentDidMount() {
    let uid = fire.auth().currentUser.uid;
    var ref = fire.database().ref(`users/` + uid);

    ref.on(
      "value",
      snap => {
        const visibility = snap.val() && snap.val().visibility;

        if (visibility === false) {
          this.setState({
            text: " Not Visible "
          });
        }
      },
      function(error) {
        console.log("Error: " + error.code);
      }
    );
  }

  handleClick() {
    let uid = fire.auth().currentUser.uid;

    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));

    fire
      .database()
      .ref("users")
      .child(uid)
      .update({
        visibility: !this.state.isToggleOn
      });

    this.toggleVisibility();
  }

  toggleVisibility() {
    let uid = fire.auth().currentUser.uid;
    var ref = fire.database().ref(`users/` + uid);

    ref.on(
      "value",
      snap => {
        const visibility = snap.val() && snap.val().visibility;

        if (visibility !== false) {
          this.setState({
            text: "Visible"
          });
        }
      },
      function(error) {
        console.log("Error: " + error.code);
      }
    );
  }

  logOut(e) {
    fire.auth().signOut();
  }

  render() {
    if (this.props.authenticated === false) {
      return <Redirect to="/" />;
    }

    return (
      <nav className="navbar navbar-inverse">
        <div className="nav navbar navbar-left">
          <img alt="dog" id="avatar-nav" src={this.props.user.avatar} />
          <div className="user-info-nav">
            <Link
              to={{
                pathname: "./profile",
                state: {
                  user: this.props.user
                }
              }}
            >
              <label id="username-nav">{this.props.user.name}</label>
            </Link>
            <button
              className="button-hover"
              id="visible-button"
              onClick={this.handleClick}
            >
              {this.state.text}
            </button>
          </div>
        </div>
        <ul className="nav navbar-nav navbar-right" />
        <Button
          className="button-hover"
          id="logout-button"
          onClick={this.logOut}
        >
          {" "}
          Log Out
        </Button>
      </nav>
    );
  }
}

export default NavBar;
